/* eslint-disable no-unused-vars */
// 画面出力用にHTMLをエスケープ
function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// 属性値向けにHTMLエスケープ
function escapeAttr(value) {
  return escapeHtml(value).replace(/"/g, "&quot;");
}

// URL判定（http/httpsのみ許可）
function isUrl(value) {
  return /^https?:\/\//i.test(value);
}

// 可能ならURL形式に正規化して返す
function normalizeHomepageUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) {
    return { href: "", isValid: false };
  }

  if (isUrl(raw)) {
    return { href: raw, isValid: true };
  }

  if (/^\/\//.test(raw)) {
    return { href: `https:${raw}`, isValid: true };
  }

  if (/^www\./i.test(raw)) {
    return { href: `https://${raw}`, isValid: true };
  }

  if (/^[a-z0-9.-]+\.[a-z]{2,}(\/.*)?$/i.test(raw)) {
    return { href: `https://${raw}`, isValid: true };
  }

  return { href: raw, isValid: false };
}

// 画像のURLを組み立てて返す（無指定なら共通のno_imageにフォールバック）
function resolveImageSources(root, folder, filename) {
  const fallbackBase = `${root}assets/img/common/no_image`;
  const fallback = {
    webp: `${fallbackBase}.webp`,
    src: `${fallbackBase}.png`,
  };
  const clean = String(filename || "").trim();
  if (!clean) return fallback;

  const hasExt = /\.[^/.]+$/.test(clean);
  const src = `${root}assets/img/${folder}/${clean}${hasExt ? "" : ".jpg"}`;
  return {
    webp: src.replace(/\.[^/.]+$/, ".webp"),
    src,
  };
}

// pictureタグを生成
function buildPictureMarkup(root, folder, filename, altText) {
  const { webp, src } = resolveImageSources(root, folder, filename);
  const alt = escapeAttr(String(altText || "").trim());
  return `
    <picture>
      <source srcset="${escapeAttr(webp)}" type="image/webp">
      <img src="${escapeAttr(src)}" alt="${alt}" width="251" height="166">
    </picture>
  `;
}
